import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faAngleDown } from "@fortawesome/free-solid-svg-icons"

export const AngleDown = (props) => {
  return <FontAwesomeIcon faIcon={faAngleDown} {...props} />
}
